export default __webpack_public_path__ + "static/media/Plan.c5fbe944.png";